import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import * as moment from 'moment';
import { combineLatest, Subject } from 'rxjs';
import { mergeMap, takeUntil, tap } from 'rxjs/operators';
import { DATE_CONST } from './../../../../../_shared/constants/date-constants.const';
import { Asset } from './../../../../../_shared/model/asset.model';
import { FcEvent } from './../../../../../_shared/model/fcEvent.model';
import { EmptySlot } from './../../../../../_shared/model/schedule/empty-slot.model';
import { Service } from './../../../../../_shared/model/service.model';
import { Subcontractor } from './../../../../../_shared/model/subcontractor.model';
import { User } from './../../../../../_shared/model/user.model';
import { HelperService } from './../../../../../_shared/services';
import { GetAndLoadAssets, GetAndLoadSubcontractors } from './../../../../../_shared/state/base/base.actions';
import { BaseState } from './../../../../../_shared/state/base/base.state';
import { CommonService } from './../../_services/common.service';

@Component({
    selector: 'main-cal-slot-popup',
    templateUrl: './main-cal-slot-popup.component.html',
    styleUrls: ['./main-cal-slot-popup.component.scss'],
})
export class MainCalSlotPopupComponent implements OnInit {
    @Input()
    event: FcEvent;

    public mainForm: FormGroup;
    public isFormSubmited: boolean;
    public allSubcontractors: Subcontractor[];
    public allAssets: Asset[];
    public servicesForSubc: Service[];
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public timeInputMask: any = [/[0-2]/, /[0-9]/, ':', /[0-5]/, /[0-9]/];
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public calendarOptions: any = this.helper.getDateSettngs(null);
    private contractorId: number = this.store.selectSnapshot(BaseState.activeContractorId);
    private onDestroy$ = new Subject<void>();

    constructor(
        public activeModal: NgbActiveModal,
        private fb: FormBuilder,
        public store: Store,
        private helper: HelperService,
        private commonRest: CommonService,
    ) {}

    ngOnInit() {
        combineLatest(
            this.store.dispatch(new GetAndLoadSubcontractors()).pipe(
                mergeMap(() => this.store.select(BaseState.getAllSubcontractors())),
                takeUntil(this.onDestroy$),
                tap((subcontractors: Subcontractor[]) => (this.allSubcontractors = subcontractors)),
            ),

            this.store.dispatch(new GetAndLoadAssets()).pipe(
                mergeMap(() => this.store.select(BaseState.getAssets())),
                takeUntil(this.onDestroy$),
                // map((el) => el.filter((i) => i.assetType == AssetType.DEVICE)),
                tap((assets: Asset[]) => (this.allAssets = assets)),
            ),
        )
            .pipe(takeUntil(this.onDestroy$))
            .subscribe();
        this.initForm();
    }
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
    ngOnDestroy(): void {
        this.onDestroy$.next();
    }
    private initForm(): void {
        this.mainForm = this.fb.group({
            subcontractor: this.fb.control({ value: '', disabled: false }),
            service: this.fb.control({ value: '', disabled: false }),
            asset: this.fb.control({ value: '', disabled: false }),
            startDate: this.fb.control({
                value: this.event.start?.format(DATE_CONST.format.date.view),
                disabled: false,
            }),
            startTime: this.fb.control({
                value: this.event.start?.format(DATE_CONST.format.time.timeValue),
                disabled: false,
            }),
            endTime: this.fb.control({ value: '', disabled: false }),
        });

        // _.get(this.resRequestData, 'selectedDate', moment()).format('DD.MM.YYYY'),
        this.mainForm.controls?.subcontractor?.valueChanges
            .pipe(
                mergeMap((subc: Subcontractor) =>
                    this.commonRest
                        .getServicesForSubcontractor(this.contractorId, subc.id)
                        .pipe(tap((services: Service[]) => (this.servicesForSubc = services))),
                ),
            )
            .subscribe();

        this.mainForm?.controls?.service?.valueChanges.subscribe((service: Service) => {
            const endTime = moment(this.mainForm.value.startTime, DATE_CONST.format.time.timeValue)
                .add(service.length, 'minutes')
                .format(DATE_CONST.format.time.timeValue);

            this.mainForm?.controls?.endTime?.setValue(endTime, { emitEvent: false });
        });
        // let subcontractor: Subcontractor;
        if (this.event?.resourceId) {
            this.mainForm.controls.subcontractor.setValue(this.allSubcontractors.find(el => el.id == this.event.resourceId));
        }
    }
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    public onSubConctractorChange(): void {}

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    public setDate(): void {}
    // private getServicesForSubcontractor(subcontractorId: number) {
    //     this.commonRest
    //         .getServicesForSubcontractor(this.contractorId, subcontractorId)
    //         .pipe(tap((services: Service[]) => (this.subcServices = services)))
    //         .subscribe();
    // }
    public selectLogedinUser(): void {
        const user: User = this.store.selectSnapshot(BaseState.LoggedUser);
        if (user?.subcontractorId) {
            this.mainForm.controls.subcontractor.setValue(this.allSubcontractors.find(el => el.id == user.subcontractorId));
        }
    }

    public confirm(): void {
        this.activeModal.close(<EmptySlot>this.mainForm.value);
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public equalsAnyById(o1: any, o2: any): boolean {
        if (!o1 || !o2) {
            return;
        }
        return o1.id === o2.id;
    }
}
